import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";


const RetirarAComponent = ({cambiarEstado}) => {
  return (
    <>
            <Card>
            <CardHeader className="pb-3">
                <div className="text-center"><b>Entregar a:</b></div>
            </CardHeader>
            <CardBody>
                <Container>
                    <Row>
                        <Col>
                            <Button
                                block
                                size="lg"
                                color="info"
                                type="button"
                                onClick={() => {cambiarEstado("Cliente")}}
                            >
                                Cliente
                            </Button> 
                        </Col>
                        <Col>
                        <Button
                                block
                                size="lg"
                                color="warning"
                                type="button"
                                onClick={() => {cambiarEstado("Obra")}}
                            >
                                Obra
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </CardBody>                  
        </Card>
    </>
  )
}

export default RetirarAComponent